// src/auth.js
import { signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import { auth, googleProvider } from "./firebase";

const ALLOWED_EMAILS = [
  "moti.maaravi@gmail.com",
  "maaravi@gmail.com",
  "maaravi888@gmail.com",
];

export function isAllowed(user) {
  return user && ALLOWED_EMAILS.includes(user.email);
}

export async function login() {
  const result = await signInWithPopup(auth, googleProvider);
  return result.user;
}

export async function logout() {
  await signOut(auth);
}

export function onAuthChange(callback) {
  return onAuthStateChanged(auth, callback);
}
